// Liste officielle des 163 communes des Alpes-Maritimes (INSEE, COG 2026)
export const COMMUNES = [
  "Aiglun", "Amirat", "Andon", "Antibes", "Ascros", "Aspremont",
  "Auribeau-sur-Siagne", "Auvare", "Bairols", "Le Bar-sur-Loup",
  "Beaulieu-sur-Mer", "Beausoleil", "Belvédère", "Bendejun", "Berre-les-Alpes",
  "Beuil", "Bézaudun-les-Alpes", "Biot", "Blausasc", "La Bollène-Vésubie",
  "Bonson", "Bouyon", "Breil-sur-Roya", "Briançonnet", "La Brigue", "Le Broc",
  "Cabris", "Cagnes-sur-Mer", "Caille", "Cannes", "Le Cannet", "Cantaron",
  "Cap-d'Ail", "Carros", "Castagniers", "Castellar", "Castillon", "Caussols",
  "Châteauneuf-Grasse", "Châteauneuf-Villevieille", "Châteauneuf-d'Entraunes",
  "Cipières", "Clans", "Coaraze", "La Colle-sur-Loup", "Collongues",
  "Colomars", "Conségudes", "Contes", "Courmes", "Coursegoules", "La Croix-sur-Roudoule",
  "Cuébris", "Daluis", "Drap", "Duranus", "Entraunes", "L'Escarène",
  "Escragnolles", "Falicon", "Les Ferres", "Fontan", "Gars", "Gattières",
  "La Gaude", "Gilette", "Gorbio", "Gourdon", "Grasse", "Gréolières",
  "Guillaumes", "Ilonse", "Isola", "Lantosque", "Levens", "Lieuche", "Lucéram",
  "Malaussène", "Mandelieu-la-Napoule", "Marie", "Le Mas", "Massoins", "Menton",
  "Mouans-Sartoux", "Mougins", "Moulinet", "Les Mujouls", "Nice", "Opio",
  "Peille", "Peillon", "La Penne", "Peymeinade", "Pierlas", "Pierrefeu",
  "Puget-Rostang", "Puget-Théniers", "Pégomas", "Péone", "Revest-les-Roches",
  "Rigaud", "Rimplas", "La Roque-en-Provence", "Roquebillière",
  "Roquebrune-Cap-Martin", "Roquefort-les-Pins", "Roquestéron",
  "La Roquette-sur-Siagne", "La Roquette-sur-Var", "Roubion", "Roure",
  "Le Rouret", "Saint-André-de-la-Roche", "Saint-Antonin", "Saint-Auban",
  "Saint-Blaise", "Saint-Cézaire-sur-Siagne", "Saint-Dalmas-le-Selvage",
  "Saint-Étienne-de-Tinée", "Sainte-Agnès", "Saint-Jean-Cap-Ferrat",
  "Saint-Jeannet", "Saint-Laurent-du-Var", "Saint-Léger",
  "Saint-Martin-d'Entraunes", "Saint-Martin-du-Var", "Saint-Martin-Vésubie",
  "Saint-Paul-de-Vence", "Saint-Sauveur-sur-Tinée", "Saint-Vallier-de-Thiey",
  "Sallagriffon", "Saorge", "Sauze", "Sigale", "Sospel", "Spéracèdes",
  "Séranon", "Tende", "Thiéry", "Théoule-sur-Mer", "Le Tignet", "Toudon",
  "La Tour", "Tourette-du-Château", "Tournefort", "Tourrette-Levens",
  "Tourrettes-sur-Loup", "Touët-de-l'Escarène", "Touët-sur-Var", "La Trinité",
  "La Turbie", "Utelle", "Valbonne", "Valdeblore", "Valderoure", "Vallauris",
  "Venanson", "Vence", "Villars-sur-Var", "Villefranche-sur-Mer",
  "Villeneuve-d'Entraunes", "Villeneuve-Loubet", "Èze",
];

// Normalise pour la recherche (retire accents / casse)
export const normalize = (s) =>
  s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

// Première lettre en majuscule sans accent pour le filtre alphabétique
export const firstLetter = (s) =>
  normalize(s.replace(/^(le |la |les |l')/i, "")).charAt(0).toUpperCase();

// Slug URL stable pour les pages locales (identique côté génération du sitemap)
export const slugify = (s) =>
  s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
    .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

export const COMMUNE_BY_SLUG = COMMUNES.reduce((m, c) => {
  m[slugify(c)] = c;
  return m;
}, {});
